import type { ReactElement } from 'react';
import React from 'react';
import type {
  TextStyle,
  TextProps as RNTextProps,
  Text as RNText,
} from 'react-native';

import { TYPE_CONFIG } from '@garnish/constants';
import { useFluidTextStyles } from '../useFluidTextStyles';
import type { TextProps } from '../Text';
import { Text } from '../Text';

type Props = {
  readonly size?: SizeOrdinal;
  readonly children?: React.ReactNode;
  readonly underline?: boolean;
} & RNTextProps &
  TextProps;

export const TitleText = React.forwardRef(
  (props: Props, ref: React.Ref<RNText>): ReactElement<Text> => {
    const { size = DEFAULT_SIZE, style, children, ...rest } = props;
    const responsiveStyles = useFluidTextStyles(PRESET_MAP[size], 'TITLE');

    const stylesFromPresets = getStylesFromPresets(size);
    const titleTextStyles = [stylesFromPresets, responsiveStyles, style];

    return (
      <Text ref={ref} style={titleTextStyles} {...rest}>
        {children}
      </Text>
    );
  },
);

/* -- utils, etc ------------------------------------------------------------ */

const PRESET_MAP = {
  0: '120',
  1: '80',
  2: '64',
  3: '48',
  4: '40',
  5: '32',
  6: '24',
  7: '18',
};

const DEFAULT_SIZE: SizeOrdinal = 1;

const getStylesFromPresets = (size: SizeOrdinal): TextStyle => {
  const configKey = PRESET_MAP[size];

  return TYPE_CONFIG.TITLE[configKey];
};

type SizeOrdinal = keyof typeof PRESET_MAP;
